module.exports = "/interactives/anyang/life-in-the-city/_next/static/images/artifact-5a477b27a9a632e5ea106ce85885a971.png";